<template>
  <div class="label-box">
    <span class="label-shadow" :style="shadowColor ? { color: shadowColor } : null">
      <slot />
    </span>
    <span class="label-text" :style="textColor ? { color: textColor } : null">
      <slot />
    </span>
  </div>
</template>

<script setup>
// 双层文字描边 label (shadow 描边 + text 覆盖). 内容通过 <slot/> 只写一遍, 组件内部 render 两遍.
// 颜色优先级: prop (inline style) > CSS var (--label-shadow-color / --label-text-color, 父类可传主题色) > fallback default
defineOptions({ name: 'UiLabel' })
defineProps({
  shadowColor: { type: String, default: '' },
  textColor:   { type: String, default: '' }
})
</script>

<style lang="scss" scoped>
// 只 override color, 描边 stroke / position 等继承全局 .label-box (app.scss)
.label-shadow { color: var(--label-shadow-color, #000); }
.label-text   { color: var(--label-text-color, #fff); }
</style>
